import {SuspendedComponent} from 'components/SuspendedComponent';
import {Detail as DetailComponent} from './Detail';
import {dataLoader} from './dataLoader';

export const Detail = () => (
  <SuspendedComponent dataLoader={dataLoader} component={DetailComponent} />
);
